"use strict";
"use es6";
/* tslint:disable:no-empty */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
function noop() {}
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/util/noop.js
// module id = 111
// module chunks = 0